module.exports = __webpack_public_path__ + "img/call.67b74302.svg";